import { StorageKey } from '../enums/StorageKey'
import { generateHitId } from './generateHitId'

interface VisitUser {
  id: string
  new: boolean
}

function getVisitUser(hit: string): VisitUser {
  let id = typeof window !== 'undefined' && localStorage.getItem(StorageKey.User)

  if (id) {
    return { id, new: false }
  } else {
    id = hit

    typeof window !== 'undefined' && localStorage.setItem(StorageKey.User, id)

    return { id, new: true }
  }
}

interface VisitSession {
  id: string
  new: boolean
}

function getVisitSession(hit: string): VisitSession {
  let id = typeof window !== 'undefined' && sessionStorage.getItem(StorageKey.Session)

  if (id) {
    return { id, new: false }
  } else {
    id = hit

    typeof window !== 'undefined' && sessionStorage.setItem(StorageKey.Session, id)

    return { id, new: true }
  }
}

interface VisitInfo {
  user: VisitUser
  session: VisitSession
  hit: string
}

function getVisitInfo(): VisitInfo {
  const hit = generateHitId()

  return {
    user: getVisitUser(hit),
    session: getVisitSession(hit),
    hit,
  }
}

export const visitInfo = getVisitInfo()
